// from Webamp demo

const album = "Freestyles: Nostalgia";

export const initialTracks = [
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/01%20-%20Nostalgia%20-%20Freestyle%20001.mp3",
    duration: 142,
    metaData: {
      title: "Freestyle 001",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/02%20-%20Nostalgia%20-%20Freestyle%20002.mp3",
    duration: 133,
    metaData: {
      title: "Freestyle 002",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/03%20-%20Nostalgia%20-%20Freestyle%20003.mp3",
    duration: 126,
    metaData: {
      title: "Freestyle 003",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/04%20-%20Nostalgia%20-%20Freestyle%20004.mp3",
    duration: 245,
    metaData: {
      title: "Freestyle 004",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/05%20-%20Nostalgia%20-%20Freestyle%20005.mp3",
    duration: 151,
    metaData: {
      title: "Freestyle 005",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/06%20-%20Nostalgia%20-%20Freestyle%20006.mp3",
    duration: 183,
    metaData: {
      title: "Freestyle 006",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/07%20-%20Nostalgia%20-%20Freestyle%20007.mp3",
    duration: 143,
    metaData: {
      title: "Freestyle 007",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/08%20-%20Nostalgia%20-%20Freestyle%20008.mp3",
    duration: 210,
    metaData: {
      title: "Freestyle 008",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/09%20-%20Nostalgia%20-%20Freestyle%20009.mp3",
    duration: 148,
    metaData: {
      title: "Freestyle 009",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/10%20-%20Nostalgia%20-%20Freestyle%20010.mp3",
    duration: 193,
    metaData: {
      title: "Freestyle 010",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/11%20-%20Nostalgia%20-%20Freestyle%20011.mp3",
    duration: 245,
    metaData: {
      title: "Freestyle 011",
      artist: "Nostalgia",
      album
    }
  },
  {
    url:
      "https://raw.githubusercontent.com/nelsontineojr/nostalgia-files/refs/heads/main/12%20-%20Nostalgia%20-%20Freestyle%20012.mp3",
    duration: 138,
    metaData: {
      title: "Freestyle 012",
      artist: "Nostalgia",
      album
    }
  }
];
